import TDatePicker from './DatePicker.vue'

export const DatePicker = TDatePicker
